import { Box } from '@mui/material';
import React, { CSSProperties, ReactElement } from 'react';
import { colorSkeletonBackground } from 'customColors';
import { BaseSkeleton } from './BaseSkeleton';

export interface EventBriefSkeletonProps {
  styles?: CSSProperties;
}

export const squareSkeleton = (width = '25px', height = '25px') => {
  return <BaseSkeleton height={height} width={width} />;
};

export const circleSkeleton = (width = '25px', height = '25px') => {
  return (
    <BaseSkeleton
      height={height}
      width={width}
      styles={{ borderRadius: '50%', marginLeft: '5px' }}
    />
  );
};

export const EventBriefSkeleton = ({
  styles = {},
}: EventBriefSkeletonProps): ReactElement => {
  return (
    <Box
      sx={{
        width: 320,
        height: 'auto',
        border: `1px solid ${colorSkeletonBackground}`,
        ...styles,
      }}
    >
      <Box
        sx={{
          height: 160,
          width: '100%',
          backgroundColor: colorSkeletonBackground,
        }}
      ></Box>
      <Box p={16}>
        <BaseSkeleton />
        <BaseSkeleton width="90%" />
        <BaseSkeleton width="50%" />
        <BaseSkeleton width="50%" />

        <Box display="flex" mt={8}>
          {squareSkeleton()}

          <Box ml="auto" display="flex">
            {circleSkeleton()}
            {circleSkeleton()}
            {circleSkeleton()}
            {circleSkeleton()}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
